import { type ApiResult, type BaseParams, type EditionsType, links, Request } from '@app/client';

export async function getEditions(params: BaseParams): Promise<ApiResult<EditionsType>> {
    return Request.getRequest<EditionsType>({
        ...params,
        target: links.editions(),
    });
}
